// Zodiac signs data with symbols, dates, elements, ruling planets, and Indian Rashi names
export const ZODIAC_SIGNS = [
  { name: 'Aries', rashi: 'Mesha', rashiTe: 'మేషం', nameTe: 'మేషం', symbol: '♈', emoji: '🐏', dates: 'Mar 21 - Apr 19', datesTe: 'మార్చి 21 - ఏప్రిల్ 19', element: 'Fire', ruler: 'Mars', color: '#c0392b', startMonth: 3, startDay: 21, endMonth: 4, endDay: 19 },
  { name: 'Taurus', rashi: 'Vrishabha', rashiTe: 'వృషభం', nameTe: 'వృషభం', symbol: '♉', emoji: '🐂', dates: 'Apr 20 - May 20', datesTe: 'ఏప్రిల్ 20 - మే 20', element: 'Earth', ruler: 'Venus', color: '#8B6914', startMonth: 4, startDay: 20, endMonth: 5, endDay: 20 },
  { name: 'Gemini', rashi: 'Mithuna', rashiTe: 'మిథునం', nameTe: 'మిథునం', symbol: '♊', emoji: '👯', dates: 'May 21 - Jun 20', datesTe: 'మే 21 - జూన్ 20', element: 'Air', ruler: 'Mercury', color: '#0e8a6d', startMonth: 5, startDay: 21, endMonth: 6, endDay: 20 },
  { name: 'Cancer', rashi: 'Karka', rashiTe: 'కర్కాటకం', nameTe: 'కర్కాటకం', symbol: '♋', emoji: '🦀', dates: 'Jun 21 - Jul 22', datesTe: 'జూన్ 21 - జులై 22', element: 'Water', ruler: 'Moon', color: '#0e8a6d', startMonth: 6, startDay: 21, endMonth: 7, endDay: 22 },
  { name: 'Leo', rashi: 'Simha', rashiTe: 'సింహం', nameTe: 'సింహం', symbol: '♌', emoji: '🦁', dates: 'Jul 23 - Aug 22', datesTe: 'జులై 23 - ఆగస్టు 22', element: 'Fire', ruler: 'Sun', color: '#c0392b', startMonth: 7, startDay: 23, endMonth: 8, endDay: 22 },
  { name: 'Virgo', rashi: 'Kanya', rashiTe: 'కన్య', nameTe: 'కన్య', symbol: '♍', emoji: '👩', dates: 'Aug 23 - Sep 22', datesTe: 'ఆగస్టు 23 - సెప్టెంబర్ 22', element: 'Earth', ruler: 'Mercury', color: '#8B6914', startMonth: 8, startDay: 23, endMonth: 9, endDay: 22 },
  { name: 'Libra', rashi: 'Tula', rashiTe: 'తుల', nameTe: 'తుల', symbol: '♎', emoji: '⚖️', dates: 'Sep 23 - Oct 22', datesTe: 'సెప్టెంబర్ 23 - అక్టోబర్ 22', element: 'Air', ruler: 'Venus', color: '#8B6914', startMonth: 9, startDay: 23, endMonth: 10, endDay: 22 },
  { name: 'Scorpio', rashi: 'Vrishchika', rashiTe: 'వృశ్చికం', nameTe: 'వృశ్చికం', symbol: '♏', emoji: '🦂', dates: 'Oct 23 - Nov 21', datesTe: 'అక్టోబర్ 23 - నవంబర్ 21', element: 'Water', ruler: 'Pluto', color: '#0e8a6d', startMonth: 10, startDay: 23, endMonth: 11, endDay: 21 },
  { name: 'Sagittarius', rashi: 'Dhanu', rashiTe: 'ధనుస్సు', nameTe: 'ధనుస్సు', symbol: '♐', emoji: '🏹', dates: 'Nov 22 - Dec 21', datesTe: 'నవంబర్ 22 - డిసెంబర్ 21', element: 'Fire', ruler: 'Jupiter', color: '#c0392b', startMonth: 11, startDay: 22, endMonth: 12, endDay: 21 },
  { name: 'Capricorn', rashi: 'Makara', rashiTe: 'మకరం', nameTe: 'మకరం', symbol: '♑', emoji: '🐐', dates: 'Dec 22 - Jan 19', datesTe: 'డిసెంబర్ 22 - జనవరి 19', element: 'Earth', ruler: 'Saturn', color: '#8B6914', startMonth: 12, startDay: 22, endMonth: 1, endDay: 19 },
  { name: 'Aquarius', rashi: 'Kumbha', rashiTe: 'కుంభం', nameTe: 'కుంభం', symbol: '♒', emoji: '🏺', dates: 'Jan 20 - Feb 18', datesTe: 'జనవరి 20 - ఫిబ్రవరి 18', element: 'Air', ruler: 'Uranus', color: '#0e8a6d', startMonth: 1, startDay: 20, endMonth: 2, endDay: 18 },
  { name: 'Pisces', rashi: 'Meena', rashiTe: 'మీనం', nameTe: 'మీనం', symbol: '♓', emoji: '🐟', dates: 'Feb 19 - Mar 20', datesTe: 'ఫిబ్రవరి 19 - మార్చి 20', element: 'Water', ruler: 'Neptune', color: '#8B6914', startMonth: 2, startDay: 19, endMonth: 3, endDay: 20 },
];

export const PLANETS = ['Sun', 'Moon', 'Mercury', 'Venus', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune', 'Pluto'];

export const HOUSES = [
  { number: 1, name: 'First House', meaning: 'Self, Appearance, Identity' },
  { number: 2, name: 'Second House', meaning: 'Money, Possessions, Values' },
  { number: 3, name: 'Third House', meaning: 'Communication, Siblings, Short Trips' },
  { number: 4, name: 'Fourth House', meaning: 'Home, Family, Roots' },
  { number: 5, name: 'Fifth House', meaning: 'Creativity, Romance, Children' },
  { number: 6, name: 'Sixth House', meaning: 'Health, Work, Daily Routine' },
  { number: 7, name: 'Seventh House', meaning: 'Partnerships, Marriage' },
  { number: 8, name: 'Eighth House', meaning: 'Transformation, Shared Resources' },
  { number: 9, name: 'Ninth House', meaning: 'Philosophy, Travel, Higher Education' },
  { number: 10, name: 'Tenth House', meaning: 'Career, Public Image, Status' },
  { number: 11, name: 'Eleventh House', meaning: 'Friends, Groups, Hopes' },
  { number: 12, name: 'Twelfth House', meaning: 'Subconscious, Spirituality, Secrets' },
];

// Rider-Waite-Smith Tarot Deck (Public Domain - 1909)
// Local images stored in public/images/tarot/
// Full 78-card deck: 22 Major Arcana + 56 Minor Arcana

// Major Arcana (22 cards)
export const MAJOR_ARCANA = [
  { name: 'The Fool', number: 0, image: '/images/tarot/00-fool.jpg', arcana: 'major' },
  { name: 'The Magician', number: 1, image: '/images/tarot/01-magician.jpg', arcana: 'major' },
  { name: 'The High Priestess', number: 2, image: '/images/tarot/02-high-priestess.jpg', arcana: 'major' },
  { name: 'The Empress', number: 3, image: '/images/tarot/03-empress.jpg', arcana: 'major' },
  { name: 'The Emperor', number: 4, image: '/images/tarot/04-emperor.jpg', arcana: 'major' },
  { name: 'The Hierophant', number: 5, image: '/images/tarot/05-hierophant.jpg', arcana: 'major' },
  { name: 'The Lovers', number: 6, image: '/images/tarot/06-lovers.jpg', arcana: 'major' },
  { name: 'The Chariot', number: 7, image: '/images/tarot/07-chariot.jpg', arcana: 'major' },
  { name: 'Strength', number: 8, image: '/images/tarot/08-strength.jpg', arcana: 'major' },
  { name: 'The Hermit', number: 9, image: '/images/tarot/09-hermit.jpg', arcana: 'major' },
  { name: 'Wheel of Fortune', number: 10, image: '/images/tarot/10-wheel.jpg', arcana: 'major' },
  { name: 'Justice', number: 11, image: '/images/tarot/11-justice.jpg', arcana: 'major' },
  { name: 'The Hanged Man', number: 12, image: '/images/tarot/12-hanged-man.jpg', arcana: 'major' },
  { name: 'Death', number: 13, image: '/images/tarot/13-death.jpg', arcana: 'major' },
  { name: 'Temperance', number: 14, image: '/images/tarot/14-temperance.jpg', arcana: 'major' },
  { name: 'The Devil', number: 15, image: '/images/tarot/15-devil.jpg', arcana: 'major' },
  { name: 'The Tower', number: 16, image: '/images/tarot/16-tower.jpg', arcana: 'major' },
  { name: 'The Star', number: 17, image: '/images/tarot/17-star.jpg', arcana: 'major' },
  { name: 'The Moon', number: 18, image: '/images/tarot/18-moon.jpg', arcana: 'major' },
  { name: 'The Sun', number: 19, image: '/images/tarot/19-sun.jpg', arcana: 'major' },
  { name: 'Judgement', number: 20, image: '/images/tarot/20-judgement.jpg', arcana: 'major' },
  { name: 'The World', number: 21, image: '/images/tarot/21-world.jpg', arcana: 'major' },
];

// Minor Arcana - Wands (14 cards)
export const WANDS = [
  { name: 'Ace of Wands', suit: 'wands', value: 1, image: '/images/tarot/wands-01.jpg', arcana: 'minor' },
  { name: 'Two of Wands', suit: 'wands', value: 2, image: '/images/tarot/wands-02.jpg', arcana: 'minor' },
  { name: 'Three of Wands', suit: 'wands', value: 3, image: '/images/tarot/wands-03.jpg', arcana: 'minor' },
  { name: 'Four of Wands', suit: 'wands', value: 4, image: '/images/tarot/wands-04.jpg', arcana: 'minor' },
  { name: 'Five of Wands', suit: 'wands', value: 5, image: '/images/tarot/wands-05.jpg', arcana: 'minor' },
  { name: 'Six of Wands', suit: 'wands', value: 6, image: '/images/tarot/wands-06.jpg', arcana: 'minor' },
  { name: 'Seven of Wands', suit: 'wands', value: 7, image: '/images/tarot/wands-07.jpg', arcana: 'minor' },
  { name: 'Eight of Wands', suit: 'wands', value: 8, image: '/images/tarot/wands-08.jpg', arcana: 'minor' },
  { name: 'Nine of Wands', suit: 'wands', value: 9, image: '/images/tarot/wands-09.jpg', arcana: 'minor' },
  { name: 'Ten of Wands', suit: 'wands', value: 10, image: '/images/tarot/wands-10.jpg', arcana: 'minor' },
  { name: 'Page of Wands', suit: 'wands', value: 11, image: '/images/tarot/wands-page.jpg', arcana: 'minor' },
  { name: 'Knight of Wands', suit: 'wands', value: 12, image: '/images/tarot/wands-knight.jpg', arcana: 'minor' },
  { name: 'Queen of Wands', suit: 'wands', value: 13, image: '/images/tarot/wands-queen.jpg', arcana: 'minor' },
  { name: 'King of Wands', suit: 'wands', value: 14, image: '/images/tarot/wands-king.jpg', arcana: 'minor' },
];

// Minor Arcana - Cups (14 cards)
export const CUPS = [
  { name: 'Ace of Cups', suit: 'cups', value: 1, image: '/images/tarot/cups-01.jpg', arcana: 'minor' },
  { name: 'Two of Cups', suit: 'cups', value: 2, image: '/images/tarot/cups-02.jpg', arcana: 'minor' },
  { name: 'Three of Cups', suit: 'cups', value: 3, image: '/images/tarot/cups-03.jpg', arcana: 'minor' },
  { name: 'Four of Cups', suit: 'cups', value: 4, image: '/images/tarot/cups-04.jpg', arcana: 'minor' },
  { name: 'Five of Cups', suit: 'cups', value: 5, image: '/images/tarot/cups-05.jpg', arcana: 'minor' },
  { name: 'Six of Cups', suit: 'cups', value: 6, image: '/images/tarot/cups-06.jpg', arcana: 'minor' },
  { name: 'Seven of Cups', suit: 'cups', value: 7, image: '/images/tarot/cups-07.jpg', arcana: 'minor' },
  { name: 'Eight of Cups', suit: 'cups', value: 8, image: '/images/tarot/cups-08.jpg', arcana: 'minor' },
  { name: 'Nine of Cups', suit: 'cups', value: 9, image: '/images/tarot/cups-09.jpg', arcana: 'minor' },
  { name: 'Ten of Cups', suit: 'cups', value: 10, image: '/images/tarot/cups-10.jpg', arcana: 'minor' },
  { name: 'Page of Cups', suit: 'cups', value: 11, image: '/images/tarot/cups-page.jpg', arcana: 'minor' },
  { name: 'Knight of Cups', suit: 'cups', value: 12, image: '/images/tarot/cups-knight.jpg', arcana: 'minor' },
  { name: 'Queen of Cups', suit: 'cups', value: 13, image: '/images/tarot/cups-queen.jpg', arcana: 'minor' },
  { name: 'King of Cups', suit: 'cups', value: 14, image: '/images/tarot/cups-king.jpg', arcana: 'minor' },
];

// Minor Arcana - Swords (14 cards)
export const SWORDS = [
  { name: 'Ace of Swords', suit: 'swords', value: 1, image: '/images/tarot/swords-01.jpg', arcana: 'minor' },
  { name: 'Two of Swords', suit: 'swords', value: 2, image: '/images/tarot/swords-02.jpg', arcana: 'minor' },
  { name: 'Three of Swords', suit: 'swords', value: 3, image: '/images/tarot/swords-03.jpg', arcana: 'minor' },
  { name: 'Four of Swords', suit: 'swords', value: 4, image: '/images/tarot/swords-04.jpg', arcana: 'minor' },
  { name: 'Five of Swords', suit: 'swords', value: 5, image: '/images/tarot/swords-05.jpg', arcana: 'minor' },
  { name: 'Six of Swords', suit: 'swords', value: 6, image: '/images/tarot/swords-06.jpg', arcana: 'minor' },
  { name: 'Seven of Swords', suit: 'swords', value: 7, image: '/images/tarot/swords-07.jpg', arcana: 'minor' },
  { name: 'Eight of Swords', suit: 'swords', value: 8, image: '/images/tarot/swords-08.jpg', arcana: 'minor' },
  { name: 'Nine of Swords', suit: 'swords', value: 9, image: '/images/tarot/swords-09.jpg', arcana: 'minor' },
  { name: 'Ten of Swords', suit: 'swords', value: 10, image: '/images/tarot/swords-10.jpg', arcana: 'minor' },
  { name: 'Page of Swords', suit: 'swords', value: 11, image: '/images/tarot/swords-page.jpg', arcana: 'minor' },
  { name: 'Knight of Swords', suit: 'swords', value: 12, image: '/images/tarot/swords-knight.jpg', arcana: 'minor' },
  { name: 'Queen of Swords', suit: 'swords', value: 13, image: '/images/tarot/swords-queen.jpg', arcana: 'minor' },
  { name: 'King of Swords', suit: 'swords', value: 14, image: '/images/tarot/swords-king.jpg', arcana: 'minor' },
];

// Minor Arcana - Pentacles (14 cards)
export const PENTACLES = [
  { name: 'Ace of Pentacles', suit: 'pentacles', value: 1, image: '/images/tarot/pentacles-01.jpg', arcana: 'minor' },
  { name: 'Two of Pentacles', suit: 'pentacles', value: 2, image: '/images/tarot/pentacles-02.jpg', arcana: 'minor' },
  { name: 'Three of Pentacles', suit: 'pentacles', value: 3, image: '/images/tarot/pentacles-03.jpg', arcana: 'minor' },
  { name: 'Four of Pentacles', suit: 'pentacles', value: 4, image: '/images/tarot/pentacles-04.jpg', arcana: 'minor' },
  { name: 'Five of Pentacles', suit: 'pentacles', value: 5, image: '/images/tarot/pentacles-05.jpg', arcana: 'minor' },
  { name: 'Six of Pentacles', suit: 'pentacles', value: 6, image: '/images/tarot/pentacles-06.jpg', arcana: 'minor' },
  { name: 'Seven of Pentacles', suit: 'pentacles', value: 7, image: '/images/tarot/pentacles-07.jpg', arcana: 'minor' },
  { name: 'Eight of Pentacles', suit: 'pentacles', value: 8, image: '/images/tarot/pentacles-08.jpg', arcana: 'minor' },
  { name: 'Nine of Pentacles', suit: 'pentacles', value: 9, image: '/images/tarot/pentacles-09.jpg', arcana: 'minor' },
  { name: 'Ten of Pentacles', suit: 'pentacles', value: 10, image: '/images/tarot/pentacles-10.jpg', arcana: 'minor' },
  { name: 'Page of Pentacles', suit: 'pentacles', value: 11, image: '/images/tarot/pentacles-page.jpg', arcana: 'minor' },
  { name: 'Knight of Pentacles', suit: 'pentacles', value: 12, image: '/images/tarot/pentacles-knight.jpg', arcana: 'minor' },
  { name: 'Queen of Pentacles', suit: 'pentacles', value: 13, image: '/images/tarot/pentacles-queen.jpg', arcana: 'minor' },
  { name: 'King of Pentacles', suit: 'pentacles', value: 14, image: '/images/tarot/pentacles-king.jpg', arcana: 'minor' },
];

// Full 78-card deck
export const TAROT_CARDS = [...MAJOR_ARCANA, ...WANDS, ...CUPS, ...SWORDS, ...PENTACLES];

// Get zodiac sign from date of birth
export function getZodiacSign(month, day) {
  for (const sign of ZODIAC_SIGNS) {
    if (sign.startMonth === sign.endMonth) {
      if (month === sign.startMonth && day >= sign.startDay && day <= sign.endDay) return sign;
    } else if (sign.startMonth > sign.endMonth) {
      // Capricorn spans Dec-Jan
      if ((month === sign.startMonth && day >= sign.startDay) ||
          (month === sign.endMonth && day <= sign.endDay)) return sign;
    } else {
      if ((month === sign.startMonth && day >= sign.startDay) ||
          (month === sign.endMonth && day <= sign.endDay)) return sign;
    }
  }
  return ZODIAC_SIGNS[0]; // default
}

// Calculate life path number for numerology
export function calculateLifePathNumber(dateStr) {
  const digits = dateStr.replace(/\D/g, '');
  let sum = digits.split('').reduce((acc, d) => acc + parseInt(d, 10), 0);
  while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
    sum = sum.toString().split('').reduce((acc, d) => acc + parseInt(d, 10), 0);
  }
  return sum;
}

// Get random tarot cards
export function getRandomTarotCards(count = 3) {
  const shuffled = [...TAROT_CARDS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count).map((card, index) => ({
    ...card,
    reversed: Math.random() > 0.5,
    position: ['Past', 'Present', 'Future'][index] || `Card ${index + 1}`,
  }));
}

// Chinese zodiac
export function getChineseZodiac(year) {
  const animals = ['Rat', 'Ox', 'Tiger', 'Rabbit', 'Dragon', 'Snake', 'Horse', 'Goat', 'Monkey', 'Rooster', 'Dog', 'Pig'];
  const emojis = ['🐀', '🐂', '🐅', '🐇', '🐉', '🐍', '🐴', '🐐', '🐒', '🐓', '🐕', '🐷'];
  const index = (year - 4) % 12;
  return { animal: animals[index], emoji: emojis[index] };
}

// 27 Nakshatras
export const NAKSHATRAS = [
  { name: 'Ashwini', symbol: '🐴', deity: 'Ashwini Kumaras', ruler: 'Ketu', pada: [1, 2, 3, 4] },
  { name: 'Bharani', symbol: '🐘', deity: 'Yama', ruler: 'Venus', pada: [1, 2, 3, 4] },
  { name: 'Krittika', symbol: '🔥', deity: 'Agni', ruler: 'Sun', pada: [1, 2, 3, 4] },
  { name: 'Rohini', symbol: '🐂', deity: 'Brahma', ruler: 'Moon', pada: [1, 2, 3, 4] },
  { name: 'Mrigashira', symbol: '🦌', deity: 'Soma', ruler: 'Mars', pada: [1, 2, 3, 4] },
  { name: 'Ardra', symbol: '💎', deity: 'Rudra', ruler: 'Rahu', pada: [1, 2, 3, 4] },
  { name: 'Punarvasu', symbol: '🏹', deity: 'Aditi', ruler: 'Jupiter', pada: [1, 2, 3, 4] },
  { name: 'Pushya', symbol: '🌸', deity: 'Brihaspati', ruler: 'Saturn', pada: [1, 2, 3, 4] },
  { name: 'Ashlesha', symbol: '🐍', deity: 'Nagas', ruler: 'Mercury', pada: [1, 2, 3, 4] },
  { name: 'Magha', symbol: '👑', deity: 'Pitris', ruler: 'Ketu', pada: [1, 2, 3, 4] },
  { name: 'Purva Phalguni', symbol: '🛏️', deity: 'Bhaga', ruler: 'Venus', pada: [1, 2, 3, 4] },
  { name: 'Uttara Phalguni', symbol: '☀️', deity: 'Aryaman', ruler: 'Sun', pada: [1, 2, 3, 4] },
  { name: 'Hasta', symbol: '✋', deity: 'Savitar', ruler: 'Moon', pada: [1, 2, 3, 4] },
  { name: 'Chitra', symbol: '💎', deity: 'Vishwakarma', ruler: 'Mars', pada: [1, 2, 3, 4] },
  { name: 'Swati', symbol: '🌿', deity: 'Vayu', ruler: 'Rahu', pada: [1, 2, 3, 4] },
  { name: 'Vishakha', symbol: '🎯', deity: 'Indra-Agni', ruler: 'Jupiter', pada: [1, 2, 3, 4] },
  { name: 'Anuradha', symbol: '🪷', deity: 'Mitra', ruler: 'Saturn', pada: [1, 2, 3, 4] },
  { name: 'Jyeshtha', symbol: '👂', deity: 'Indra', ruler: 'Mercury', pada: [1, 2, 3, 4] },
  { name: 'Mula', symbol: '🦁', deity: 'Nirriti', ruler: 'Ketu', pada: [1, 2, 3, 4] },
  { name: 'Purva Ashadha', symbol: '🐘', deity: 'Apas', ruler: 'Venus', pada: [1, 2, 3, 4] },
  { name: 'Uttara Ashadha', symbol: '🐘', deity: 'Vishwadevas', ruler: 'Sun', pada: [1, 2, 3, 4] },
  { name: 'Shravana', symbol: '👂', deity: 'Vishnu', ruler: 'Moon', pada: [1, 2, 3, 4] },
  { name: 'Dhanishta', symbol: '🥁', deity: 'Vasus', ruler: 'Mars', pada: [1, 2, 3, 4] },
  { name: 'Shatabhisha', symbol: '⭕', deity: 'Varuna', ruler: 'Rahu', pada: [1, 2, 3, 4] },
  { name: 'Purva Bhadrapada', symbol: '🔥', deity: 'Ajaikapada', ruler: 'Jupiter', pada: [1, 2, 3, 4] },
  { name: 'Uttara Bhadrapada', symbol: '🐍', deity: 'Ahirbudhnya', ruler: 'Saturn', pada: [1, 2, 3, 4] },
  { name: 'Revati', symbol: '🐟', deity: 'Pushan', ruler: 'Mercury', pada: [1, 2, 3, 4] },
];

// Tarot Spreads
export const TAROT_SPREADS = {
  threeCard: {
    name: 'Three Card Spread',
    positions: ['Past', 'Present', 'Future'],
    cardCount: 3,
    description: 'A simple spread for quick insights',
  },
  celticCross: {
    name: 'Celtic Cross',
    positions: [
      'Present Situation',
      'Challenge/Obstacle',
      'Past Influences',
      'Future Influences',
      'Conscious Goals',
      'Subconscious Influences',
      'Advice',
      'External Influences',
      'Hopes and Fears',
      'Final Outcome',
    ],
    cardCount: 10,
    description: 'A comprehensive spread for deep insights',
  },
  loveSpread: {
    name: 'Love Spread',
    positions: ['You', 'Your Partner', 'The Relationship', 'Challenges', 'Advice'],
    cardCount: 5,
    description: 'For relationship questions and love matters',
  },
  careerSpread: {
    name: 'Career Spread',
    positions: ['Current Situation', 'Obstacles', 'Hidden Influences', 'Advice', 'Outcome'],
    cardCount: 5,
    description: 'For career and professional guidance',
  },
  yesNo: {
    name: 'Yes/No',
    positions: ['Answer'],
    cardCount: 1,
    description: 'Simple yes/no questions',
  },
};

// Get tarot cards for a specific spread
export function getTarotCardsForSpread(spreadType) {
  const spread = TAROT_SPREADS[spreadType] || TAROT_SPREADS.threeCard;
  const shuffled = [...TAROT_CARDS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, spread.cardCount).map((card, index) => ({
    ...card,
    reversed: Math.random() > 0.5,
    position: spread.positions[index] || `Card ${index + 1}`,
  }));
}

// Gemstone recommendations by zodiac
export const GEMSTONES = {
  Aries: { primary: 'Red Coral', secondary: 'Ruby', avoid: 'Blue Sapphire' },
  Taurus: { primary: 'Diamond', secondary: 'Emerald', avoid: 'Red Coral' },
  Gemini: { primary: 'Emerald', secondary: 'Green Tourmaline', avoid: 'Red Coral' },
  Cancer: { primary: 'Pearl', secondary: 'Moonstone', avoid: 'Blue Sapphire' },
  Leo: { primary: 'Ruby', secondary: 'Peridot', avoid: 'Blue Sapphire' },
  Virgo: { primary: 'Emerald', secondary: 'Peridot', avoid: 'Red Coral' },
  Libra: { primary: 'Diamond', secondary: 'Opal', avoid: 'Ruby' },
  Scorpio: { primary: 'Red Coral', secondary: 'Garnet', avoid: 'Emerald' },
  Sagittarius: { primary: 'Yellow Sapphire', secondary: 'Topaz', avoid: 'Diamond' },
  Capricorn: { primary: 'Blue Sapphire', secondary: 'Amethyst', avoid: 'Ruby' },
  Aquarius: { primary: 'Blue Sapphire', secondary: 'Amethyst', avoid: 'Ruby' },
  Pisces: { primary: 'Yellow Sapphire', secondary: 'Aquamarine', avoid: 'Diamond' },
};
